<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">Suspensión</label>
        <label class="h5">Administrativa / Autoridad Competente</label>
      </header>
      <form [formGroup]="formDatos" (ngSubmit)="getRnt()">
        <div class="form-group">
          <label class="small text-secondary" for="nit"
            >Ingrese el número de RNT</label
          >
          <input
            formControlName="lista_rnt"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
        <div class="form-row mt-5">
          <button
            class="btn btn-primary m-auto"
            [disabled]="!formDatos.valid"
            type="submit"
          >
            Buscar
          </button>
        </div>
      </form>
    </section>
    <section
      class="col-9 p-4 mt-5 mb-5"
      *ngIf="datosRnt.length > 0; else no_data"
    >
      <div class="d-flex justify-content-between">
        <div>
          <img
            src="../../../../../assets/icons/solicitud.png"
            class="d-inline-block img-responsive mr-3"
            alt=""
          />
          <label class="h5">Establecimientos para suspender</label>
        </div>
      </div>
      <div class="table-responsive">
        <app-tablas
          [headers]="headers"
          [paginar]="false"
          class="table-responsive"
        >
          <tr *ngFor="let item of datosRnt">
            <td>{{ item.codigo_rnt }}</td>
            <td>{{ item.razon_social }}</td>
            <td>{{ item.descripcion_estado_rnt }}</td>
            <img
              src="/assets/icons/delete.png"
              class="pointer ml-2 mt-3"
              alt=""
              (click)="onEliminarRnt()"
              height="25"
            />
          </tr>
        </app-tablas>
      </div>
      <section class="col pl-4 pr-4">
        <form class="mr-5 ml-5 mt-3 mb-3" [formGroup]="formObservacion">
          <header>
            <h2 class="h6 mb-4 font-weight-bold">Motivo de Suspensión</h2>
          </header>
          <textarea
            formControlName="observacion"
            class="h-75 w-100 form-control"
          ></textarea>
        </form>
      </section>
      <footer class="text-center p-1">
        <button
          class="btn btn-primary paso-capacidad"
          (click)="confirm()"
          [disabled]="!formObservacion.valid"
        >
          Suspender establecimientos
        </button>
      </footer>
    </section>
    <ng-template #no_data>
      <section class="col-9 p-4 mt-5 mb-5">
        <header class="col-12">
          <figure class="figure w-100 text-center">
            <img
              class="img-fluid mb-4"
              src="../../../../../../../assets/images/sin_establecimiento.png"
            />
            <figcaption>
              <label class="h3">No hay información</label>
            </figcaption>
          </figure>
        </header>
      </section>
    </ng-template>
  </article>
</main>
